import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "tabs"
};
const _hoisted_2 = ["aria-expanded"];
const _hoisted_3 = {
  class: "page-switcher-title"
};
const _hoisted_4 = ["onMouseenter", "onClick"];
const _hoisted_5 = {
  class: "page-switcher-title"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon");
  const _component_AdminToggleDark = _resolveComponent("AdminToggleDark");
  const _component_LanguageSwitcher = _resolveComponent("LanguageSwitcher");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
    class: _normalizeClass(["page-switcher", {
      'is-open': $data.isPageMenuOpen
    }]),
    role: "navigation",
    onClick: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"])),
    onPointerdown: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["stop"])),
    onMouseenter: _cache[5] || (_cache[5] = (...args) => $options.handlePageSwitcherEnter && $options.handlePageSwitcherEnter(...args)),
    onMouseleave: _cache[6] || (_cache[6] = (...args) => $options.handlePageSwitcherLeave && $options.handlePageSwitcherLeave(...args))
  }, [_createElementVNode("div", {
    class: "page-switcher-sheet",
    role: "menu",
    onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["stop"]))
  }, [_createElementVNode("button", {
    class: "page-option is-current",
    type: "button",
    role: "menuitem",
    "aria-current": "page",
    "aria-expanded": $data.isPageMenuOpen,
    onClick: _cache[0] || (_cache[0] = _withModifiers($event => $options.handlePageOptionClick($options.activePageOption.name), ["stop"]))
  }, [_createVNode(_component_font_awesome_icon, {
    icon: $options.activePageOption.icon,
    class: "page-option-icon"
  }, null, 8, ["icon"]), _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t($options.activePageOption.label)), 1), _createVNode(_component_font_awesome_icon, {
    icon: "chevron-down",
    class: "page-switcher-arrow"
  })], 8, _hoisted_2), _createElementVNode("div", {
    class: "page-option-list",
    onMouseleave: _cache[1] || (_cache[1] = (...args) => $options.clearHoveredPageOption && $options.clearHoveredPageOption(...args))
  }, [_createElementVNode("span", {
    class: _normalizeClass(["page-option-highlight", {
      'is-visible': $data.hoveredPageOptionIndex !== null
    }]),
    style: _normalizeStyle({
      '--hovered-option-index': $data.hoveredPageOptionIndex === null ? 0 : $data.hoveredPageOptionIndex
    }),
    "aria-hidden": "true"
  }, null, 6), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.inactivePageOptions, (option, index) => {
    return _openBlock(), _createElementBlock("button", {
      key: option.name,
      class: "page-option",
      type: "button",
      role: "menuitem",
      onMouseenter: $event => $options.setHoveredPageOption(index),
      onClick: _withModifiers($event => $options.handlePageOptionClick(option.name), ["stop"])
    }, [_createVNode(_component_font_awesome_icon, {
      icon: option.icon,
      class: "page-option-icon"
    }, null, 8, ["icon"]), _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t(option.label)), 1)], 40, _hoisted_4);
  }), 128))], 32)])], 34), _createVNode(_component_AdminToggleDark), _createVNode(_component_LanguageSwitcher, {
    class: "tabs-language-switcher"
  })]);
}